export const SPECIAL_ASSISTANCE_SUBMIT = "booking/SPECIAL_ASSISTANCE_SUBMIT"
export const SPECIAL_ASSISTANCE_SUBMIT_FAILURE = "booking/SPECIAL_ASSISTANCE_SUBMIT_FAILURE"

export default SPECIAL_ASSISTANCE_SUBMIT
